<template>
  <section>
	  
	 <div class="page-list">
		 <com-page-title   ></com-page-title>
	 <el-form class="form-region" style="min-height: auto;" ref="form"  label-width="140px">
	 <el-form-item  required label='隐私政策'>
	  <com-form-editor  v-model='form.content'></com-form-editor>
	   </el-form-item>
	 <el-form-item  required label='用户协议'>
	 <com-form-editor  v-model='form.agreement'></com-form-editor>
	  </el-form-item>
	  <el-form-item  required label='关于我们'>
	  <com-form-editor  v-model='form.my'></com-form-editor>
	   </el-form-item>
	  <el-form-item required label='客服电话'>
	  <el-input placeholder='请填写'   maxlength="20"  type='text' v-model='form.tel' clearable></el-input>
	   </el-form-item>
	
	  <el-form-item>
	    <el-button type="primary" @click="onSubmit">立即提交</el-button>
	  </el-form-item>
	 </el-form>
   </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
     form:{
		content:'',
		agreement:'',
		tel:'',
		my:''
	 },
	
    }
  },
  methods: {
	  onSubmit() {
		  let data=JSON.stringify(this.form);
	  this.$axios.post('/api/Users/PostUsersConfigs' ,{content:data} ).then(e => {
		   this.$message.success('操作成功到同步服务器');
	   });
	  }, 
  },
 mounted() {
 this.$axios.get('/api/Users/GetUsersConfigs',{}).then(e => {
	 if(e)this.form=e
	   });
 },
};
</script>


